export enum ReservationStatus {
  confirmed = "confirmed",
  canceled = "canceled",
  pending = "pending",
}
